import { api } from './client';

/**
 * Pure functional auth API
 */
export const authApi = {
  // Register new user
  register: (email, password, name) =>
    api.post('/auth/register', { email, password, name }),

  // Login with optional remember me
  login: (email, password, rememberMe = false) =>
    api.post('/auth/login', { email, password, rememberMe }),

  // Logout - clears httpOnly cookie
  logout: () =>
    api.post('/auth/logout'),

  // Get authentication status
  getStatus: () => 
    api.get('/user/status'),

  // Forgot password
  forgotPassword: (email) =>
    api.post('/auth/forgot-password', { email }),

  // Reset password
  resetPassword: (token, newPassword) =>
    api.post('/auth/reset-password', { token, password: newPassword }),
};